<template>
	<div class="top-divider py-2">
		<v-textarea label="メモ(必須)" v-model="memo.content" outlined dense :rules="[rules.required]" />
		<v-row no-gutters justify="space-between">
			<h3 class="text-body-2 font-weight-bold">添付</h3>
			<v-btn dark text color="secondary" @click="$refs.uploadFile.click()">
				<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
				添付ファイルを追加
				<input type="file" class="d-none" ref="uploadFile" @change="addFiles($event)" multiple />
			</v-btn>
		</v-row>

		<div class="file-area">
			<span v-if="allFiles < 1" class="filename text-body-2">添付ファイルはありません。</span>
			<template v-else>
				<v-chip
					class="ma-1 mt-2"
					close
					label
					outlined
					color="primary"
					v-for="file in memo.existing_files"
					@click:close="openDeleteDialog(file)"
					:key="file.id"
				>
					<v-icon class="mr-1">mdi-paperclip</v-icon>
					{{ common.truncate(file.name, 20) }}
				</v-chip>
				<v-chip class="ma-1 mt-2" close label outlined color="primary" @click:close="removeFile(i)" v-for="(file, i) in memo.files" :key="file.name">
					<v-icon class="mr-1">mdi-paperclip</v-icon>
					{{ common.truncate(file.name, 20) }}
				</v-chip>
			</template>
		</div>
		<v-dialog v-model="deleteDialog" max-width="600" @click:outside="closeDeleteDialog">
			<v-card>
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white"> 添付ファイル削除 </v-app-bar-title>
				</v-app-bar>
				<v-card-text class="pa-2" color="black">
					サーバー上の添付ファイルを削除します。
					<br />
					削除したファイルは元に戻すことはできません。
					<br />
					よろしいですか
				</v-card-text>
				<v-card-actions class="ma-0">
					<v-row no-gutters class="py-4" justify="center">
						<v-col cols="0" sm="4" />
						<v-col cols="12" sm="4">
							<v-row justify="center">
								<v-btn @click="deleteFile" dense dark color="red">
									<v-icon class="mr-2">mdi-delete</v-icon>
									削除する</v-btn
								>
							</v-row>
						</v-col>
						<v-col cols="0" sm="4">
							<v-row align="center">
								<v-spacer></v-spacer>
								<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDeleteDialog"> キャンセル </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import common from "../../helper/common"

export default {
	props: {
		memo_data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			selectedFile: null,
			deleteDialog: false,
			rules: rules,
			common: common,
		}
	},
	methods: {
		removeFile(index) {
			this.memo.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.memo.files.push(file[1])
			})
		},
		openDeleteDialog(file) {
			this.deleteDialog = true
			this.selectedFile = file
		},
		deleteFile() {
			const headers = authenticate.setHeader()
			axios
				.delete(`/erp/v1/memos/${this.memo.id}/memo_files/${this.selectedFile.id}`, {
					headers,
				})
				.then((res) => {
					const index = this.memo.existing_files.indexOf(this.selectedFile)
					this.memo.existing_files.splice(index, 1)
					this.selectedFile = null
					this.deleteDialog = false
					this.$store.dispatch("setFlash", {
						text: "添付ファイルを削除しました。",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDeleteDialog() {
			this.deleteDialog = false
			this.selectedFile = null
		},
	},
	computed: {
		memo: {
			get() {
				return this.memo_data
			},
			set() {
				return this.$emit("update:memo_data", newValue)
			},
		},
		allFiles() {
			return this.memo.files.length + (this.memo.existing_files ? this.memo.existing_files?.length : 0)
		},
	},
}
</script>